import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const STAFF = ["owner", "admin", "support", "order_manager", "finance", "viewer"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); } catch { setUser(false); }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    refresh();
  }, [refresh]);
  const logout = async () => { await api.post("/auth/logout"); setUser(false); };
  const can = (perm) => !!user && (user.permissions || []).includes(perm);
  const isStaff = !!user && STAFF.includes(user.role);
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout, can, isStaff }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
